export const LOG_FLAGS = {

  ACTION_RUN: false,
  PICK: false
  
};